// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23Mua","col":"styles_col__1d0rc"};